export enum PaginationIndicatorColor {
  Primary = "primary",
  Light = "light",
  Neutral = "neutral",
  Dark = "dark",
  PrimaryInverted = "primary-inverted",
}

export enum PaginationIndicatorVariant {
  Lines = "lines",
  Dots = "dots",
}
